import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAtomoxetine} from "./TextDrugAtomoxetine"


export default function Atomoxetine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Atomoxetine' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Atomoxetine - PGx Recommendation"
        content={ <TextDrugAtomoxetine />}

        />

</>
)}